const cache = {};
export const getCache = (section, id) => {
    return cache[`${section}/${id}`];
};
export const setCache = (section, id, data) => {
    cache[`${section}/${id}`] = data;
};
